import { InlineCodeExtension } from "@productlane/lib/src/tiptap/extensions"

const CustomInlineCode = InlineCodeExtension

export default CustomInlineCode
